export const controlSpaces = (value: string): string => {
  return value.replace(/\s+/g, ' ');
};

export const removeAllSpaces = (value: string): string => {
  return value.replace(/\s/g, '');
};
